export var FILE = '__NATIVE_FILE__';
export var URL = '__NATIVE_URL__';
export var TEXT = '__NATIVE_TEXT__';


//////////////////
// WEBPACK FOOTER
// ./~/react-dnd-html5-backend/dist/esm/NativeTypes.js
// module id = 180
// module chunks = 4